import React, { useEffect, useState } from "react";
import styles from "./AddDevice.module.css";
import useAuthToken from "../../../hooks/useAuthToken";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../context/ToastContext";
import config from "../../../settings/config";

const AddDevice = () => {
    const types = ["relay", "sensor", "combo"];
    const slaveTypes = ["relay", "temperature", "humidity", "pressure", "co2"];
    const absences = ["1", "0.1", "0.01", "0.001"];
    const units = ["num", "°C", "ртс", "ppm", "%"];
    const allStatus = ["0", "1"];
    const [slaves, setSlaves] = useState([]);
    const navigate = useNavigate();
    const token = useAuthToken();
    const [sn, setSn] = useState("");
    const [name, setName] = useState("");
    const [image, setImage] = useState("");
    const [status, setStatus] = useState("");
    const [type, setType] = useState("");
    const [topic, setTopic] = useState("");
    const [buttonSwitch, setButtonSwitch] = useState(false);
    const { setToast } = useToast();
    const showToast = (message, type, time) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), time);
    };

    const addSlave = () => {
        setSlaves([...slaves, { slaveName: "", type: "", units: "", absence: "", topic: "" }]); // можно указать любые поля
    };

    //        slave.setSlaveName();
    //        slave.getType()
    //        slave.setUnits();
    //        slave.setAbsence();
    //        slave.setTopic();

    const updateSlave = (index, field, value) => {
        const newSlaves = [...slaves];
        newSlaves[index][field] = value;
        setSlaves(newSlaves);
    };

    const removeSlave = (index) => {
        const newSlaves = slaves.filter((_, i) => i !== index);
        setSlaves(newSlaves);
    };

    const saveDevice = async () => {
        // Проверка полей у устройства
        if (!sn || !name || !topic || !image || !status || !type) {
            showToast("Пожалуйста, заполните все поля устройства", "error", 3000);
            return;
        }
    
        // Проверка каждого слейва
        for (const [i, slave] of slaves.entries()) {
            if (!slave.slaveName || !slave.topic || !slave.type || !slave.units || !slave.absence) {
                showToast(`Заполните все поля у слейва №${i + 1}`, "error", 3000);
                return;
            }
        }
    
        // Если всё ок
        setButtonSwitch(true);
    
        // Формирование объекта
        const deviceData = {
            sn,
            name,
            topic,
            image,
            status,
            type,
            isAlive: true, // или false, как надо
            slaves
        };

        console.log(deviceData);

        try {
            const response = await fetch(`${config.app.host}/api/v1/admin/addDevice`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(deviceData),
            });
    
            if (response.ok) {
                showToast("Устройство успешно добавлено", "success", 3000);
                navigate("/devices"); // или куда надо после добавления
            } else {
                const errorData = await response.json();
                showToast(`Ошибка: ${errorData.message || "Не удалось сохранить устройство"}`, "error", 3000);
            }
        } catch (error) {
            showToast(`Ошибка сети: ${error.message}`, "error", 3000);
        }
    };
    

    return (
        <div className={styles.container}>
            <h3>Добавить устройство</h3>
            <div className={styles.formDevice}>
                Serial number
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите sn"
                    required
                    value={sn}
                    onChange={(e) => setSn(e.target.value)}
                />
                Name
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите name"
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                Topic
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите sn"
                    required
                    value={topic}
                    onChange={(e) => setTopic(e.target.value)}
                />
                Image
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите путь до картинки"
                    required
                    value={image}
                    onChange={(e) => setImage(e.target.value)}
                />
                <label className={styles.label}>Тип:</label>
                <select
                    className={styles.selectInput}
                    value={type}
                    onChange={(e) => setType(e.target.value)}>
                    <option value="">-- Выберите тип --</option>
                    {types.map((t) => (
                        <option key={t} value={t}>
                            {t}
                        </option>
                    ))}
                </select>
                <label className={styles.label}>Статус:</label>
                <select
                    className={styles.selectInput}
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}>
                    <option value="">-- Выберите статус --</option>
                    {allStatus.map((s) => (
                        <option key={s} value={s}>
                            {s === "1" ? "Активен" : "Неактивен"}
                        </option>
                    ))}
                </select>
            </div>
            {slaves.map((slave, index) => (
                <div key={index} className={styles.slaveForm}>
                    Имя слейва
                    <input
                        className={styles.formInput}
                        type="text"
                        placeholder="Введите название слейва"
                        value={slave.slaveName}
                        onChange={(e) => updateSlave(index, "slaveName", e.target.value)}
                    />
                    Топик слейва
                    <input
                        className={styles.formInput}
                        type="text"
                        placeholder="Введите топик слейва"
                        value={slave.topic}
                        onChange={(e) => updateSlave(index, "topic", e.target.value)}
                    />
                    <label className={styles.label}>Тип</label>
                    <select
                        className={styles.selectInput}
                        value={slave.type}
                        onChange={(e) => updateSlave(index, "type", e.target.value)}>
                        <option value="">-- Выберите тип --</option>
                        {slaveTypes.map((t) => (
                            <option key={t} value={t}>
                                {t}
                            </option>
                        ))}
                    </select>
                    <label className={styles.label}>Единицы</label>
                    <select
                        className={styles.selectInput}
                        value={slave.units}
                        onChange={(e) => updateSlave(index, "units", e.target.value)}>
                        <option value="">-- Выберите единицу --</option>
                        {units.map((t) => (
                            <option key={t} value={t}>
                                {t}
                            </option>
                        ))}
                    </select>
                    <label className={styles.label}>Точность</label>
                    <select
                        className={styles.selectInput}
                        value={slave.absence}
                        onChange={(e) => updateSlave(index, "absence", e.target.value)}>
                        <option value="">-- Выберите точность --</option>
                        {absences.map((t) => (
                            <option key={t} value={t}>
                                {t}
                            </option>
                        ))}
                    </select>
                    <button
                        className={styles.deleteSlaveButton}
                        onClick={() => removeSlave(index)}
                    >
                        Удалить
                    </button>
                </div>
            ))}

            <button
                className={styles.addSlaveButton}
                onClick={addSlave}
            >
                Добавить слейв
            </button>

            <button
                className={buttonSwitch ? styles.addSlaveButton : styles.addSlaveButtonOff}
                onClick={saveDevice}
            >
                Сохранить новое устройство
            </button>
        </div>
    )
}

export default AddDevice;